import { Pipe, PipeTransform } from '@angular/core';
import { CrewDatePipe } from './crew-date.pipe'
import * as dataCore from "../core/datacore";

@Pipe({ name: 'crewdatewithtimezone' })
export class CrewDateWithLocalTimezonePipe implements PipeTransform {

    constructor(private crewDatePipe: CrewDatePipe) {
    }

    transform(value: Date): string {

        if (!value) {
            return "";
        }

        return this.crewDatePipe.transform(dataCore.addTimezoneOffset(value));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/crew-date-with-local-timezone.pipe.ts